// extracted by mini-css-extract-plugin
export default {"tooltip":"toolTip_tooltip__5eQR5","tooltipWpapper":"toolTip_tooltipWpapper__zjni2"};